import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'Mesaje e-mail',
  labels: {
    view_full_message: 'Vezi mesajul complet',
    status: 'Stare:',
    on: 'Activat',
    off: 'Dezactivat',
  },
  tiles: {
    sends_count: 'Mesaje trimise',
    delivery_rate: 'Rată livrare',
    delivered_suffix: 'livrate',
    open_rate: 'Rată deschidere',
    opened_suffix: 'deschise',
    click_rate: 'Rată accesare',
    clicked_suffix: 'accesate',
    spam_report_rate: 'Rată raportare spam',
    spam_reports_suffix: 'raportări',
    unsubscribe_rate: 'Rată dezabonare',
    unsubscribes_suffix: 'dezabonări',
  },
  toasts: {
    failed_to_update_status: 'Eroare la actualizarea stării',
    failed_to_load_data: 'Eroare la încărcarea datelor',
  },

  preview_modal: {
    title: 'Previzualizare șablon',
    labels: {
      subject: 'Subiect:',
      close: 'Închide',
    },
    toasts: {
      failed_to_load_data: 'Eroare la încărcarea previzualizării',
    },
    template_data: {
      recipient_name: '&lt;Prenume&gt;',
    },
  },
};
